import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useMemo,
  useState,
} from "react";
import styles from "./toast.module.scss";
import classNames from "classnames";
import { AnimatePresence, motion } from "framer-motion";
import { ToastPropsType } from "./types";
import { useIsMobile } from "@/helper/useIsMobile";
const toast = ({}, ref: React.Ref<unknown> | undefined) => {
  const [showToast, setShowToast] = useState<boolean>();
  const [toastData, setToastData] = useState<ToastPropsType>();
  const isMobile = useIsMobile();

  const setVisibility = useCallback((props: ToastPropsType) => {
    setShowToast(true);
    setToastData(props);
  }, []);

  useImperativeHandle(ref, () => ({
    setVisibility,
  }));

  useEffect(() => {
    if (showToast && !toastData?.showAlways) {
      const timer = setTimeout(() => {
        setShowToast(false);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [showToast]);

  const toastStyles = useMemo((): string => {
    switch (toastData?.type) {
      case "DARK":
        return styles.dark_container;
      case "SECONDARY":
        return styles.secondary_container;
      case "ERROR":
        return styles.error_container;
      case "PRIMARY":
      default:
        return styles.primary_container;
    }
  }, [toastData]);

  return (
    <AnimatePresence exitBeforeEnter>
      {showToast ? (
        <motion.div
          initial={{
            translateY: isMobile ? "-100%" : "100%",
            translateX: "-50%",
            opacity: 0,
          }}
          animate={{ translateY: "0%", opacity: 1 }}
          exit={{
            opacity: 0,
          }}
          className={classNames(styles.container, toastStyles)}
        >
          <h1
            className={classNames(
              styles.sub_2,
              styles.white1,
              !isMobile && styles["align_text_center"]
            )}
          >
            {toastData?.text}
          </h1>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
};

export default forwardRef(toast);
